module.exports = __webpack_public_path__ + "img/dldyq-lx.d1416598.jpg";